import React, { useState } from 'react';
import { Button, Stack, Typography, Box } from '@mui/material';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PaperCard } from 'components/Card';
import { FormProvider, TextField, VATNumber } from 'components/Form';
import useYupValidationResolver from 'hook/useYupValidationResolver';
import { companyInfoSchema } from '../validation';
import InputAdornment from '@mui/material/InputAdornment';
import { IconWrapper } from 'components/Icon';
import { validateVAT } from 'lib';
import { Loader } from 'components/Loader';

export const CompanyInfoForm = ({ nextStep, handleChange, values, title, submitLabel }) => {
  const { t } = useTranslation();
  const [ loading, setLoading ] = useState(false);
  const methods = useForm({
    mode: 'onSubmit',
    resolver: useYupValidationResolver(companyInfoSchema),
    values: values,
  });

  const onSubmit = async (data) => {
    setLoading(true);
    const isVATNumberValid = await validateVAT('SE', data.vat);
    if (isVATNumberValid) {
      nextStep();
    } else {
      setLoading(false);
      methods.setError('vat', { type: 'custom', message: t('website:auth.register.companyInfo.vatErrorMessage') });
    }
  };

  return (
    <>
    {loading && (
      <Box height={492} sx={{alignContent: "center"}}>
        <Loader />
      </Box>
    )}
    {!loading && (
    <PaperCard px={{ xs: 2, sm: 4 }} width={{ xs: 1, sm: 368 }} maxWidth={{ sm: 368 }} sx={{ mb: 5 }}>
      <Stack>
        <Typography variant="h5" sx={{ mb: 3, textAlign: "center" }}>
          {title ?? t('website:auth.register.companyInfo.title')}
        </Typography>

        <FormProvider methods={methods} onSubmit={onSubmit}>
          <Stack>
            <TextField
              name="companyName"
              label={t('website:auth.register.companyInfo.fields.companyName.label')}
              placeholder={t('website:auth.register.companyInfo.fields.companyName.placeholder')}
              required={true}
              type="text"
              autoComplete="organization"
              value={values.companyName}
              onChange={handleChange('companyName')}
              sx={{ mb: 2 }}
              fullWidth
            />
            {/* <Select disabled required fullWidth name="country" label="Country" options={countries} sx={{ mb: 2 }} /> */}
            <TextField
              name="country"
              label={t('website:auth.register.companyInfo.fields.country.label')}
              placeholder={t('website:auth.register.companyInfo.fields.country.placeholder')}
              required={true}
              type="text"
              value={values.country}
              onChange={handleChange('country')}
              sx={{ mb: 0.5 }}
              fullWidth
              disabled
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconWrapper
                      icon="lockClosed"
                      sx={{
                        svg: {
                          width: 16,
                          height: 16,
                        },
                      }}
                    />
                  </InputAdornment>
                ),
              }}
            />
            <VATNumber
              name="vat"
              label={t('website:auth.register.companyInfo.fields.vat.label')}
              required
              registration={true}
              value={values.vat}
              onChange={handleChange('vat')}
              sx={{ mb: 2 }}
              // fullWidth
              error={Boolean(methods?.formState?.errors?.vat)}
              helperText={methods?.formState?.errors?.vat?.message}
            />

            <Button
              size="large"
              type="submit"
              variant="contained"
              color="primary"
              sx={{
                mt: 2,
                mb: 0.5,
                bgcolor: "primary.light",
                '&:hover': {
                  backgroundColor: "primary.light",
                },
              }}
            >
              {submitLabel ?? t('website:auth.register.companyInfo.joinButton')}
            </Button>
          </Stack>
        </FormProvider>
      </Stack>
    </PaperCard>
  )}
  </>
  );
};
